export default {
    picUrl: 'https://cpcimg.tianranliang.com/',
    recommendStatus: {
        0: '正常',
        1: '全网',
        2: '新品',
        3: '热门',
        4: '推荐',
        5: '次顶',
        6: '置顶'
    },
    isDefault: {
        0: '非默认',
        1: '默认'
    },
    proStatus: {
        0: '未上架',
        1: '已上架'
    },
    overseaArr: {
        0: '全球购',
        1: '国内'
    },
    userStatus: {
        0: '正常',
        1: '冻结'
    },
    userLevel: {
       0: '金牌销售员',
        1: '品牌合伙人',
        2: '城市合伙人'
    },
    userChannel: {
        0: '微商',
        1: '淘宝',
        2: '实体',
        3: '其他'
    },
     isoverseaStatus: {
        0: '保税直邮',
        1: '国内现货'
    },
    iswhiteProStatus: {
        1: '白名单'
    },
    deliverStatus: {
        '-1': '未发货',
        0: '非拆单',
        1: '拆单发货'
    },
    orderStatus: {
        '-1': '已完成',
        0: '已取消',
        1: '待支付',
        2: '待发货',
        201: '拆单件',
        3: '收货中',
        4: '已收货',
        5: '已删除',
        6: '售后中',
        601: '已处理'
    },
    wuliuStatus: {
        'canvassing': 1,
        'checkin_scan': 2,
        'checkout_scan': 2,
        'checkout': 2,
        'deliver_to_forwarder': 2,
        'international_transport': 2,
        'cross_border_transport': 2,
        'customs_clearance': 2,
        'customs_release': 3,
        'express_delivery': 4,
        '50': 4,
        '3036': 4,
        '44': 4,
        '8000': 5,
        '9000': 6
    },
    wuliuCompany: {
       // 0: 'UEQ',
        0: "极兔快递",
        1: '中通快递',
        2: "圆通快递" ,
        3: '申通快递',
        4: "中国邮政",
        5: '韵达快递',
        6: "德邦快递" ,
        7: "京东快递" ,
        8: "顺丰快递",
        9: "菜鸟快递",
        10: "壹米滴答",
        11: "韵达快运",
        12: "中通快运",
        13: "百世快运" ,
        14: "安能物流" ,
        15: "顺心捷达" 
    },
    tixianStatus: {
        0: '提现中',
        1: '提现成功'
    },
    jiesuanStatus: {
        0: '未结算',
        1: '已结算'
    },
     baoyouStatus: {
        0: '不包邮',
        1: '包邮'
    },
    spiderStatus: {
        0: '正常',
        1: '失效',
        2: '删除'
    },
    spiderMode: {
        1: '多规格',
        2: '单规格'
    },
    
    anjianStatus:{
         0: '非按件计算',
        1: '按件计算'
    },
    tongyongStatus:{
         0: '非通用',
        1: '通用'
    },
    shengFen:{
        0: '其他',
        1: '北京',
        2: '天津',
        3: '河北省',
        4: '山西省',
        5: '内蒙古',
        6: '辽宁省',
        7: '吉林省',
        8: '黑龙江省',
        9: '上海',
        10: '江苏省',
        11: '浙江省',
        12: '安徽省',
        13: '福建省',
        14: '江西省',
        15: '山东省',
        16: '河南省',
        17: '湖北省',
        18: '湖南省',
        19: '广东省',
        20: '广西',
        21: '海南省',
        22: '重庆',
        23: '四川省',
        24: '贵州省',
        25: '云南省',
        26: '西藏',
        27: '陕西省',
        28: '甘肃省',
        29: '青海省',
        30: '宁夏',
        31: '新疆',
        32: '台湾省',
        33: '香港',
        34: '澳门',
        35: '华东仓',
        36: '华南仓',
        37: '华北仓',
        38: '西南仓',
        39: '东北仓',
        40: '西北仓',
        41: '保税仓'
    },
    indexStatus: {
        1: '热卖',
        2: '狗狗膳食',
        3: '猫咪膳食',
        4: '宠物零食',
        5: '营养保健',
        6: '医疗护理',
        7: '猫狗玩具',
        8: '出行装备',
        9: '猫砂厕所',
        10: '家居日用',
        11: '美容服饰',
        12: '保税直邮',
        13: '云仓现货',
        14: '京东直供',
        15: '跨界优选',
        16: '罐头餐盒',
        17: '共创品牌'
    },
    verifyStatus: {
        0: '未审核',
        1: '已审核'
    },
    iswhiteStatus : {
        0: '普通客户',
        1: '白名单客户'
    },
   recommend: {
        0: '未推荐',
        1: '已推荐'
    },
    verify: {
        0: '通过审核',
        1: '新增待审核',
        2: '修改待审核'
    },
    status: {
        0: '正常',
        1: '删除'
    },
    supportStatus: {
        0: '不支持',
        1: '支持'
    },
    huiyuanLevel: {
        0: '金牌销售员',
        1: '品牌合伙人',
        2: '城市合伙人'
    },
    huiyuanChannel: {
        0: '微商',
        1: '淘宝',
        2: '实体',
        3: '其他'
    },
    sexStatus: {
        0: '未知',
        1: '男',
        2: '女'
    },
    adminLevel: {
        0: '供应商',
        1: '系统管理员'
    },
    isHot: {
        0: '非热门',
        1: '热门'
    }
}


// WEBPACK FOOTER //
// ./src/static/config/basicdata.js